export const notificationsSaveConstants = {
  NOTIFICATIONS_SAVE_REQUEST: 'NOTIFICATIONS_SAVE_REQUEST',
  NOTIFICATIONS_SAVE_SUCCESS: 'NOTIFICATIONS_SAVE_SUCCESS',
  NOTIFICATIONS_SAVE_FAILURE: 'NOTIFICATIONS_SAVE_FAILURE',
};
